import api from './api';
import type {
  CrmCatalogoCreate,
  CrmMotivoPerdida,
  CrmOrigen,
  CrmTag,
  CrmTagCreate,
} from '../types/crm';

const crmCatalogoService = {
  getTags: async (): Promise<CrmTag[]> => {
    const response = await api.get<CrmTag[]>('/api/CrmTags');
    return response.data;
  },

  createTag: async (dto: CrmTagCreate): Promise<CrmTag> => {
    const response = await api.post<CrmTag>('/api/CrmTags', dto);
    return response.data;
  },

  getOrigenes: async (): Promise<CrmOrigen[]> => {
    const response = await api.get<CrmOrigen[]>('/api/CrmOrigenes');
    return response.data;
  },

  createOrigen: async (dto: CrmCatalogoCreate): Promise<CrmOrigen> => {
    const response = await api.post<CrmOrigen>('/api/CrmOrigenes', dto);
    return response.data;
  },

  updateOrigen: async (id: number, dto: CrmCatalogoCreate): Promise<CrmOrigen> => {
    const response = await api.put<CrmOrigen>(`/api/CrmOrigenes/${id}`, dto);
    return response.data;
  },

  getMotivosPerdida: async (): Promise<CrmMotivoPerdida[]> => {
    const response = await api.get<CrmMotivoPerdida[]>('/api/CrmMotivosPerdida');
    return response.data;
  },

  createMotivoPerdida: async (dto: CrmCatalogoCreate): Promise<CrmMotivoPerdida> => {
    const response = await api.post<CrmMotivoPerdida>('/api/CrmMotivosPerdida', dto);
    return response.data;
  },

  updateMotivoPerdida: async (id: number, dto: CrmCatalogoCreate): Promise<CrmMotivoPerdida> => {
    const response = await api.put<CrmMotivoPerdida>(`/api/CrmMotivosPerdida/${id}`, dto);
    return response.data;
  },
};

export default crmCatalogoService;
